import { useEffect } from "react";
import Reveal from "@/components/Reveal";
import Eyebrow from "@/components/Eyebrow";
import { IMG } from "@/lib/images";



/*const TEAM = [
  {
    name: "E. Bishop",
    role: "Creative Director",
    image: IMG.teamA,
  },
  {
    name: "Studio Team",
    role: "Design & Build",
    image: IMG.teamB,
  },
  {
    name: "Studio Team",
    role: "Photography & Social",
    image: IMG.teamC,
  },
  {
    name: "Studio Team",
    role: "Hosting & Care",
    image: IMG.teamD,
  },
];*/

export default function About() {
  useEffect(() => {
    document.title = "About — Bishop Creative";
  }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative pt-28 md:pt-40 pb-16 md:pb-24">
        <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow>About the studio</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h1 className="mt-8 font-display text-5xl md:text-7xl lg:text-[92px] leading-[0.95] tracking-[-0.02em] max-w-[18ch]">
                Made by students. Shaped by the Central Coast.
              </h1>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-10 max-w-[56ch] text-[color:var(--text-2)] text-lg leading-[1.8]">
                Bishop Creative is a student-run creative agency based in San Luis Obispo, California. 
                We build websites, manage social media, and help local businesses show up online the way 
                they deserve to — at a price that actually works for small business owners.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.18}>
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={IMG.heroAbout}
                  alt="Vineyard in late afternoon light"
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div
                  aria-hidden
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(11,10,8,0.08) 0%, rgba(11,10,8,0.5) 100%)",
                  }}
                />
                <div className="noise-overlay" />
                <figcaption className="absolute left-4 bottom-4 right-4 flex items-center justify-between">
                  <span className="eyebrow text-[color:var(--text-2)]">
                    Central Coast · Late afternoon
                  </span>
                  <span className="eyebrow text-[color:var(--text-3)]">Plate 02</span>
                </figcaption>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <div className="container-page">
        <div className="hairline-strong" />
      </div>

      {/* ORIGIN STORY */}
      <section className="section-pad">
        <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>Origin</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-display text-3xl md:text-4xl leading-[1.1] tracking-[-0.01em]">
                Our story.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="space-y-6 text-[color:var(--text-2)] leading-[1.9] text-[16.5px] max-w-[68ch]">
                <p>
                  Bishop Creative started with a simple observation. We're students
                  living in San Luis Obispo, and we kept seeing local businesses we 
                  loved — great restaurants, cool shops, talented service providers
                  — with no real online presence. Meanwhile we had the skills to fix that.
                </p>
                <p>
                  So we built something. An agency run by local students, offering the 
                  kind of websites and media that used to cost tens of thousands of dollars,
                  at a price that actually works for a small business owner. Not a class project.
                  A real business built by people who care about this community because we live in it.
                </p>
                <p>
                  Every client we work with is a business we'd genuinely recommend to a friend. 
                  That's the standard we hold ourselves to.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.24}>
              <blockquote className="mt-16 border-l border-[color:rgba(198,168,106,0.65)] pl-6 max-w-[60ch]">
                <p className="font-display text-2xl md:text-3xl leading-[1.25] text-[color:var(--text-1)]">
                  “Local roots. Lasting impressions. Two ideas, one practice.”
                </p>
                <div className="mt-4 eyebrow text-[color:var(--text-3)]">
                  Our Promise
                </div>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </section>



      {/* TEAM
      <section className="section-pad">
        <div className="container-page">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <Reveal>
                <Eyebrow>The Studio</Eyebrow>
              </Reveal>
              <Reveal delay={0.08}>
                <h2 className="mt-6 font-display text-4xl md:text-5xl leading-[1.05] tracking-[-0.01em]">
                  A small hand, a steady one.
                </h2>
              </Reveal>
            </div>
            <Reveal delay={0.12}>
              <p className="max-w-[42ch] text-[color:var(--text-2)] leading-[1.75]">
                A rotating studio of Cal Poly students working under continuous
                creative direction. Every project is led by a senior and
                shipped by the studio.
              </p>
            </Reveal>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {TEAM.map((m, i) => (
              <Reveal key={`${m.name}-${i}`} delay={i * 0.06}>
                <figure>
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img
                      src={m.image}
                      alt={m.name}
                      className="absolute inset-0 h-full w-full object-cover grayscale-[15%]"
                    />
                    <div
                      aria-hidden
                      className="absolute inset-0"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(11,10,8,0.15) 0%, rgba(11,10,8,0.55) 100%)",
                      }}
                    />
                    <div className="noise-overlay" />
                  </div>
                  <figcaption className="mt-4">
                    <div className="font-display text-xl text-[color:var(--text-1)]">
                      {m.name}
                    </div>
                    <div className="mt-1 eyebrow">{m.role}</div>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>*/}

    </div>
  );
}
